import React, { useState, useEffect } from 'react'
import '../../pages/SurveyStart.scss';
import { useDispatch, useSelector } from 'react-redux';
import { submitCaracteristicsSurveyAnswerAction } from '../../redux/attemptSurvey/attemptSurvey.actions';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const SurveyCaracteristics = ({
  characteristicQuestionId,
  comment,
  setComment,
  survey,
  isCharacteristic,
  setSelectedOption,
  setSelectedOptions,
  selectedOptions,
  handleCheckboxChange,
  questionList,
  selectedOption,
  questionIndex,
  question,
  mandatory,
  options,
  counts,
  onChange,
  onNext
}) => {
  const dispatch = useDispatch();
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const navigate = useNavigate();
  const { isLoading } = useSelector((state) => state?.attemptSurveyInfo);

  const language = localStorage.getItem('language') || 'Italian';
  console.log("Question", questionList);
  console.log("Options", options);

  const texts = {
    Italian: {
      selectOptionError: "Seleziona un'opzione",
      characteristicQuestion: "Domanda Caratteristica",
      loading: "Invio in corso...",
      saveAndContinue: "Salva e Continua"
    },
    English: {
      selectOptionError: "Please select an option",
      characteristicQuestion: "Characteristic Question",
      loading: "Submitting...",
      saveAndContinue: "Save and Continue"
    }
  };

  // Compare selected answer (could be string/ObjectId or option object) to option
  const isSelected = (selected, option) => {
    if (selected == null || option == null) return false;
    const selectedId = typeof selected === 'object' ? selected._id || selected.option || null : selected;
    const optionId = typeof option === 'object' ? option._id || option.option || null : option;
    if (selectedId == null || optionId == null) return false;
    return String(selectedId) === String(optionId);
  };

  useEffect(() => {
    if (selectedOption) {
      setSelectedAnswer(selectedOption);
    }
  }, [selectedOption]);

  const handleOptionSelect = (option) => {
    const id = (option && typeof option === 'object' && option._id) ? option._id : option;
    setSelectedAnswer(id);
    setSelectedOption(id);
  };

  const handleNext = () => {
    if (!selectedAnswer) {
      toast.error(language === 'Italian' ? "Seleziona un'opzione" : "Please select an option");
      return;
    }

    dispatch(submitCaracteristicsSurveyAnswerAction(
      survey,
      characteristicQuestionId,
      selectedAnswer
    )).then(() => {
      onNext();
    });
  };

  return (
    <div>
      <div className="title">
        <button>
          {language === 'Italian' ? 'Domanda Caratteristica' : 'Characteristic Question'}
        </button>
      </div>
      <div className="question_card">
        <div className="question_count">
          <div className="counts"><span>{questionIndex + 1}</span>/{questionList.length}</div>
        </div>
        <div className="question">
          {questionIndex + 1}. {question}
        </div>
        <div className="option_wrapper">
          {options?.map((option, index) => (
            <label key={index} className="option" htmlFor={`${questionIndex}-${index}`}>
              <input
                type="radio"
                name={`question-${questionIndex}`}
                id={`${questionIndex}-${index}`}
                checked={isSelected(selectedAnswer, option)}
                onChange={() => handleOptionSelect(option)}
              />
              <div className="text">
                {option?.option || option}
              </div>
              <div className="right">
                <div className="tick"></div>
              </div>
            </label>
          ))}
        </div>
        <div className="action center" style={{ cursor: 'pointer' }}>
          <button
            className="next_button"
            onClick={handleNext}
          >
            {isLoading ? (language === 'Italian' ? "Invio in corso..." : "Submitting...") : (language === 'Italian' ? "Salva e Continua" : "Save and Continue")}
          </button>
        </div>
      </div>
    </div>
  )
}

export default SurveyCaracteristics
